<template>
  <div class="pt-5">
    <SimpleSectionHeader
      class="tw-pt-[170px]"
      :wellFormatted="true"
      :title="mainTitle"
    >
    </SimpleSectionHeader>

    <div class="container">
      <EngagementRsePolitique :cms-docs-by-var="cmsDocsByVar" />
    </div>
    <div class="container">
      <div class="section-title mb-4">
        <h2 class="text-start mb-3 pt-5 tw-normal-case">
          {{ engagementsTitle }}
        </h2>
      </div>
    </div>
    <EngagementRseDemarche />
  </div>
</template>

<script>
import {
  APP_ADDRESS,
  APP_EMAIL,
  APP_NAME,
  APP_PHONE,
} from "../../statics/app_static";
import { buildCmsDocsByVar, fetchCmsPublicPage, stripHtml } from "../../statics/cms";
import SimpleSectionHeader from "../generics/Headers/SimpleSectionHeader/SimpleSectionHeader.vue";
import EngagementRseDemarche from "./accueil-components/EngagementRse/EngagementRseDemarche.vue";
import EngagementRsePolitique from "./accueil-components/EngagementRse/EngagementRsePolitique.vue";

export default {
  name: "EngagementRse",
  components: {
    SimpleSectionHeader,
    EngagementRsePolitique,
    EngagementRseDemarche,
  },
  data() {
    return {
      APP_NAME,
      APP_ADDRESS,
      APP_EMAIL,
      APP_PHONE,
      cmsDocsByVar: {},
      mainTitle: "Engagement RSE",
      engagementsTitle: "Nos Engagements RSE : plus qu'un concept, une realite.",
    };
  },
  mounted() {
    this.loadCmsTexts();
  },
  methods: {
    async loadCmsTexts() {
      try {
        const { texts } = await fetchCmsPublicPage("engagement-rse");
        this.cmsDocsByVar = buildCmsDocsByVar(texts, {
          APP_NAME: this.APP_NAME,
          APP_EMAIL: this.APP_EMAIL,
          APP_ADDRESS: this.APP_ADDRESS,
          APP_PHONE: this.APP_PHONE,
        });

        if (this.cmsDocsByVar["main-title"]?.body) {
          this.mainTitle = stripHtml(this.cmsDocsByVar["main-title"].body);
        }
        if (this.cmsDocsByVar["engagements-title"]?.body) {
          this.engagementsTitle = stripHtml(this.cmsDocsByVar["engagements-title"].body);
        }
      } catch {
        this.cmsDocsByVar = {};
      }
    },
  },
};
</script>
